module.exports = __webpack_public_path__ + "img/广州白云.de39f734.png";